import { AxiosResponse } from 'axios';
import { throttle } from '../config';
import { wait } from '../utils/wait';
import axiosClient from '../utils/axios-client';
import { PaginationAndFilter } from '../interfaces/common/pagination';
import { ServiceTypeModel, ServiceTypeFormModel } from '../interfaces/masters/service/service';

class ServiceMasterApi {
  async getAllServices():
  Promise<{ responseData: ServiceTypeModel[], statusCode: number }> {
    if (throttle) {
      await wait(throttle);
    }

    try {
      const res = await axiosClient.get('master/service').then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response,
        statusCode: error.status
      });
    }
  }

  // get service by id
  async getServiceById(id: string):
  Promise<{ responseData: ServiceTypeModel, statusCode: number }> {
    if (throttle) {
      await wait(throttle);
    }

    try {
      const res = await axiosClient.get(`master/service/getById/${id}`).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async getServiceByPaginationAndFilters(options: PaginationAndFilter):
  Promise<{ responseData: any, statusCode: number }> {
    if (throttle) {
      await wait(throttle);
    }
    try {
      const res = await axiosClient.post('master/service/getByPaginationAndFilter', options).then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  // calls api to add service type in the database
  async addServiceType(serviceType: ServiceTypeFormModel): Promise<AxiosResponse> {
    if (throttle) {
      await wait(throttle);
    }

    const response = await axiosClient.post('master/service', serviceType);

    return response;
  }

  // calls put api to update service type
  async updateServiceType(serviceType: ServiceTypeFormModel): Promise<AxiosResponse> {
    if (throttle) {
      await wait(throttle);
    }

    const response = await axiosClient.put('master/service', serviceType);

    return response;
  }
}

export const serviceMasterApi = new ServiceMasterApi();
